// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

const FB_SDK_ID = 'facebook-jssdk';
const FB_SDK_SRC = 'https://connect.facebook.net/en_US/sdk.js';
const FB_GRAPH_VERSION = 'v26.0';

let sdkPromise = null;

export const initFacebookSdk = () => {
  if (sdkPromise) {
    return sdkPromise;
  }

  sdkPromise = new Promise((resolve) => {
    if (window.FB) {
      resolve(window.FB);
      return;
    }

    window.fbAsyncInit = function fbAsyncInit() {
      window.FB.init({
        appId: process.env.APP_ID_FACEBOOK,
        cookie: true,
        xfbml: false,
        version: FB_GRAPH_VERSION,
      });
      resolve(window.FB);
    };

    if (document.getElementById(FB_SDK_ID)) {
      return;
    }
    const js = document.createElement('script');
    js.id = FB_SDK_ID;
    js.src = FB_SDK_SRC;
    js.async = true;
    js.defer = true;
    js.crossOrigin = 'anonymous';
    document.body.appendChild(js);
  });

  return sdkPromise;
};

export const loginWithFacebook = (callback) => {
  if (!window.FB) {
    callback({});
    return;
  }

  window.FB.login(
    (response) => {
      callback(response && response.authResponse ? response.authResponse : {});
    },
    { scope: 'public_profile,email' },
  );
};
